const undefinedOrNull = v => typeof v === 'undefined' || v === null;
export default undefinedOrNull;
